import { fromMetricKey, isMetricWithType } from 'reporting-data/v2/dataset/datasetMetrics';

// this is an util fuction to solve discrepancies on how we get aggregation type for SF vs SO
// for SO, the aggregation type got emebeded in the field key
// however for SF, the aggregation type is not part of the field key
export const getAggregationType = ({
  channel,
  layer
}) => {
  const field = layer.getIn([channel, 'field']);
  // when the metrics is not part of the field id
  // we will get it from the dataset - properties - name
  // mainly this is only being used for SF
  const metricField = field && isMetricWithType(field) ? field : layer.getIn(['dataset', 'properties', field, 'name']);
  const metricAggregation = fromMetricKey(metricField);
  return metricAggregation.type;
};